import React from "react";
import { useTranslation } from "react-i18next";

import { Testimonials } from "../../components/common/Testimonials";
import { Footer } from "../../components/common/Footer";
import { Header } from "../../components/common/Header";

export function ThanksPage() {
  const { t } = useTranslation();
  return (
    <>
      <Header />
      <div className="container-fluid ">
        <div className="container">
          <div className="thank_page ">
            <div className="thanks over">
              <h2>{t("Thank You!")} </h2>
            </div>
            <img className="flow" src="./images/thank_banner.png" />
          </div>
        </div>
      </div>
      <Testimonials />
      <Footer />
    </>
  );
}
